<template>
  <div class="call wow fadeIn"
       data-wow-delay="50ms">
    <div>
      专业咨询顾问，为您提供1对1专属服务
    </div>
    <router-link to="/consultate">立即咨询</router-link>
  </div>
</template>

<script>
import { Component, Prop, Vue } from "vue-property-decorator";

@Component()
export default class Call extends Vue {}
</script>

<style lang='less' scoped>
.call {
  text-align: center;
  background-color: #e61717;
  color: #fff;
  padding: 72px 0;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  font-size: 0;

  div {
    display: inline-block;
    vertical-align: middle;
    font-size: 40px;
  }

  a {
    margin-left: 25px;
    display: inline-block;
    border: 1px solid #fff;
    position: relative;
    vertical-align: middle;
    background-color: #fff;
    color: #e61717;
    font-size: 20px;
    line-height: 48px;
    height: 50px;
    width: 180px;
    text-align: center;
    transition: all 0.4s ease-in-out;

    &:hover {
      -webkit-transform: translateY(-4px);
      -ms-transform: translateY(-4px);
      transform: translateY(-4px);
      box-shadow: 0 12px 24px rgba(8, 30, 80, 0.1);
    }
  }
}

@media only screen and (max-width: 768px) {
  .call {
    text-align: center;
    background-color: #e61717;
    line-height: 50px;
    color: #fff;
    padding: 40px 0;

    div {
      font-size: 20px;
      line-height: 32px;
      display: block;
    }

    a {
      margin: 20px 0 0;
      height: 40px;
      line-height: 40px;
      width: 120px;
      font-size: 16px;
    }

    img {
      display: inline-block;
      width: 25vw;
      position: relative;
      top: 6px;
      margin-top: 5vw;
    }
  }
}
</style>
